import { useQuery } from "@tanstack/react-query";
import ProductCategoryAPI from "../api/ProductCategory";

export default function useProductCategoryManager() {
  const keys = {
    getAll: "get-all-product-category",
  };

  function getProductCategory() {
    return useQuery({
      queryKey: [keys.getAll],
      queryFn: (ctx) => ProductCategoryAPI.getProductCategories(ctx),
    });
  }

  return { getProductCategory };
}
